module.exports = __webpack_public_path__ + "img/bg_bottom.d2f7eb9a.png";